<!--Header section starts-->
<!-- <section class="FirstScroll_Section">
    <div class="container">
    <div class="row text-center">
    <h2 style="color: #000;text-align: center;width: 100%; margin-bottom: 30px;">FAQ<span
    style="color: red;">s</span></h2>
    </div> -->

<!--Previous code starts-->
    <!-- <div class="row">
    
    <div class="col-md-12 col-sm-12 col-xs-12 nopad">
    
    <div class="col-md-3 col-sm-3 col-xs-12 floatLeft">
    
    <ul id="FaqsleftMenu" class="nav nav-tabs tabs-left sideways">
    <li><a href="#general-v" data-toggle="tab" class="active" routerLinkActive="active">
    <p>General</p>
    </a></li>
    <li><a href="#institute-v" data-toggle="tab" routerLinkActive="active">
    <p>Institute</p>
    </a></li>
    <li><a href="#student-v" data-toggle="tab" routerLinkActive="active">
    <p>Students</p>
    </a></li>
    <li><a href="#faculty-v" data-toggle="tab" routerLinkActive="active">
    <p>Faculty</p>
    </a></li>
    </ul>
    </div>
    
    <div class="tab-content">
    <div class="col-md-9 col-sm-9 col-xs-12 floatLeft tab-pane active" id="general-v"> 
    <mat-accordion>
        <div class="text-center alert alert-danger" style="font-size: 15px;padding: 0px;" *ngIf="generalFaqs[0]==null">
            <p style="padding: 2px;">No General FAQs</p>
        </div>
        <div *ngFor="let faq of generalFaqs">
            
        <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
            <mat-expansion-panel-header>
                <mat-panel-title>{{faq?.title}}</mat-panel-title>
                <mat-panel-description></mat-panel-description>
            </mat-expansion-panel-header>
            <p>{{faq?.body}}</p>
        </mat-expansion-panel>
        
        </div>
    </mat-accordion>
</div>

<div class="col-md-9 col-sm-9 col-xs-12 floatLeft tab-pane" id="institute-v"> 
    <mat-accordion>
        <div class="text-center alert alert-danger" style="font-size: 15px;padding: 0px;" *ngIf="instituteFaqs[0]==null">
            <p style="padding: 2px;">No Institute FAQs</p>
        </div>
        <div *ngFor="let faq of instituteFaqs">
        <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
            <mat-expansion-panel-header>
                <mat-panel-title>{{faq?.title}}</mat-panel-title>
                <mat-panel-description></mat-panel-description>
            </mat-expansion-panel-header>
            <p>{{faq?.body}}</p>
        </mat-expansion-panel>
        </div>
    </mat-accordion>
</div>

<div class="col-md-9 col-sm-9 col-xs-12 floatLeft tab-pane" id="student-v"> 
    <mat-accordion>
        <div class="text-center alert alert-danger" style="font-size: 15px;padding: 0px;" *ngIf="studentFaqs[0]==null">
            <p style="padding: 2px;">No Student FAQs</p>
        </div>
        <div *ngFor="let faq of studentFaqs">

        <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
            <mat-expansion-panel-header>
                <mat-panel-title>{{faq?.title}}</mat-panel-title>
                <mat-panel-description></mat-panel-description>
            </mat-expansion-panel-header>
            <p>{{faq?.body}}</p>
        </mat-expansion-panel>

        </div>
        
    </mat-accordion>
</div>

<div class="col-md-9 col-sm-9 col-xs-12 floatLeft tab-pane" id="faculty-v"> 
    <mat-accordion>
        <div class="text-center alert alert-danger" style="font-size: 15px;padding: 0px;" *ngIf="facultyFaqs[0]==null">
            <p style="padding: 2px;">No Faculty FAQs</p>
        </div>
        <div *ngFor="let faq of facultyFaqs">
        <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
            <mat-expansion-panel-header>
                <mat-panel-title>{{faq?.title}}</mat-panel-title>
                <mat-panel-description></mat-panel-description>
            </mat-expansion-panel-header>
            <p>{{faq?.body}}</p>
        </mat-expansion-panel>
    </div>
    </mat-accordion>
</div>


</div>
    
    </div>
    
    </div> -->
<!--Previous code ends-->

<!--New design starts-->
<!-- <form [formGroup]="faqForm" autocomplete="off" (submit)="onSubmit(faqForm.value)">
    <mat-form-field [floatLabel]="'never'" class="col-5">
        <mat-label>FAQs for</mat-label>
        <mat-icon matPrefix class="mat-icon-sm mb-2 mr-2 secondary-text-color">question_answer</mat-icon>
        <mat-select formControlName="role" required>
            <mat-option value="2">General</mat-option>
            <mat-option value="5">Institutes</mat-option>
            <mat-option value="6">Students</mat-option>
            <mat-option value="8">Faculty</mat-option>
        </mat-select>
    </mat-form-field>

    <mat-form-field [floatLabel]="'never'" class="col-5">
        <mat-label>Nature</mat-label>
        <mat-icon matPrefix class="mat-icon-sm mb-2 mr-2 secondary-text-color">help</mat-icon>
        <mat-select required>
            <mat-option value="1">Easy</mat-option>
            <mat-option value="2">Moderate</mat-option>
            <mat-option value="3">Difficult</mat-option>
        </mat-select>
    </mat-form-field>

    <button class="btn w-10 mt-3 LoginBtn" type="submit">Submit</button>

</form> -->

<!--Design 1 with mat-table-->
    <!-- <div class="col-md-12 col-sm-12 col-12 nopad">
        <table mat-table #matTable matSort [dataSource]="dataSource">
            <ng-container matColumnDef="Sno">
                <th class="text-center" mat-header-cell *matHeaderCellDef>S.No</th>
                <td class="text-center" mat-cell *matCellDef="let row;let i=index">
                    {{paginator.pageIndex == 0 ? i + 1 : 1 + i + paginator.pageIndex * paginator.pageSize}} 
                </td>
            </ng-container>
            <ng-container matColumnDef="title">
                <th class="text-center" mat-header-cell *matHeaderCellDef>Title</th>
                <td class="text-center" mat-cell *matCellDef="let row;">
                    {{row.title}}
                </td>
            </ng-container>
            <ng-container matColumnDef="body">
                <th class="text-center" mat-header-cell *matHeaderCellDef>Body</th>
                <td class="text-center" mat-cell *matCellDef="let row;">
                    {{row.body}}
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
    </div>
    <div class="col-md-12 col-sm-12 col-12 AdminSectionHeading">
        <div *ngIf="dataSource.data.length === 0">
            <br>
            <br>
            <p class="no-records-found"> No Records Found! </p>
        </div>
        <mat-paginator [pageSizeOptions]="[10, 25, 50]" showFirstLastButtons>
        </mat-paginator>
    </div> -->
<!--Design 1 ends-->

<!--Design 2 with mat-accordion starts-->
    <!-- <div class="row" style="padding-top: 20px;">
    <div class="col-md-12 col-sm-12 col-xs-12 nopad">

    <div class="tab-content">
        <div class="col-md-12 col-sm-12 col-xs-12 floatLeft tab-pane active"> 
            
        <mat-accordion multi class="mat-table">
            <div class="text-center alert alert-danger" style="font-size: 15px;padding: 0px;" *ngIf="generalFaqs[0]==null">
                <p style="padding: 2px;">No FAQs</p>
            </div>
            <div *ngFor="let faq of selectedResults">
                
            <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
                <mat-expansion-panel-header>
                    <mat-panel-title>{{faq?.title}}</mat-panel-title>
                    <mat-panel-description></mat-panel-description>
                </mat-expansion-panel-header>
                <p>{{faq?.body}}</p>
            </mat-expansion-panel>
            
            </div>
        </mat-accordion>
        <mat-paginator #paginator
            [length]="length"
            [pageSize]="pageSize"
            [pageSizeOptions]="pageSizeOptions"
            (page)="pageEvent= getData($event)" showFirstLastButtons
        ></mat-paginator>
        </div>
    </div>
    </div>
    </div> -->
<!--Design 2 ends-->
    
    <!-- </div>
</section> -->
<!--Header section ends-->



<section class="FirstScroll_Section" style="background-color: #cecccc;">
    <h3 class="SectionHeading">How can we help you?</h3>
    <div class="container h-100">
        <div class="d-flex justify-content-center h-100">
          <div class="searchbar">
            <input matinput placeholder="Type keywords to find answers" type="text" id="searchInput" class="search_input" name="search" [(ngModel)]=search (keyup)="applyFilter($event)">
            <a class="search_icon"><i class="fa fa-search"></i></a>
          </div>
        </div>
      </div>
      <h6 class="SectionHeading" style="margin-top: 30px;">You can also browse the topics below to find what you are looking for.</h6>
</section>

<section class="SecondScroll_Section">

    <form [formGroup]="faqForm" autocomplete="off" (submit)="onSubmit(faqForm.value)">
        <mat-form-field [floatLabel]="'never'" class="col-2" style="margin-left: 30px;">
            <mat-label>FAQs for</mat-label>
            <mat-select formControlName="role" required>
                <mat-option value="1">All</mat-option>
                <mat-option value="2">General</mat-option>
                <mat-option value="3">Experts</mat-option>
                <mat-option value="4">Reviewers</mat-option>
                <mat-option value="5">Institutes</mat-option>
                <mat-option value="6">Students</mat-option>
                <!-- <mat-option value="8">Faculty</mat-option> -->
                <mat-option value="10">Nodal</mat-option>
            </mat-select>
        </mat-form-field>
    
        <mat-form-field [floatLabel]="'never'" class="col-2">
            <mat-label>Nature</mat-label>
            <mat-select formControlName="nature" required>
                <mat-option value="Information Related">Information Related</mat-option>
            </mat-select>
        </mat-form-field>
    
        <button class="LoginBtn" type="submit">Apply Filter</button>
    
    </form>
    <table mat-table class="mt-4" [dataSource]="dataSource" style="width: 100%; border:none;">
        <ng-container matColumnDef="nameFaq">
          <td *matCellDef="let element">
            <div class="container-input">
                <div class="ques">
                    <div class="question clearfix"><a class="quesSymbol">Q. </a><span class="quesText">{{element.title}}</span>
                        <span class="general" *ngIf="element.role_id==2 || element.role_id==0">General</span>
                        <span class="experts" *ngIf="element.role_id==3">Experts</span>
                        <span class="reviewers" *ngIf="element.role_id==4">Reviewers</span>
                        <span class="institute" *ngIf="element.role_id==5">Institute</span>
                        <span class="students" *ngIf="element.role_id==6">Students</span>
                        <span class="nodal" *ngIf="element.role_id==10">Nodal</span>
                    </div>
                </div>
                <div class="ans">
                    <div class="answer"><a class="ansSymbol">A. </a>{{element.body}}</div>
                </div>
            </div>
          </td>
        </ng-container>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
      <mat-paginator #paginator [pageSize]="5" [pageSizeOptions]="[5, 10, 20, 50]"></mat-paginator>


    <!-- <mat-paginator #paginator
        [length]="length"
        [pageSize]="pageSize"
        [pageSizeOptions]="pageSizeOptions"
        (page)="pageEvent= getData($event)" showFirstLastButtons></mat-paginator> -->
</section>